import { useSelectors } from '@exodus/headless-react';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import useConfig from './use-config.js';
import useFromAmount from './use-from-amount.js';
import useFromAsset from './use-from-asset.js';
import useToAmount from './use-to-amount.js';
import useToAsset from './use-to-asset.js';
import usePrefilledAmountId from './use-prefilled-amount-id.js';
import useFromWalletAccount from './use-from-wallet-account.js';
import useToWalletAccount from './use-to-wallet-account.js';
const useSetInitialPair = (params) => {
    const [fromWalletAccount, setFromWalletAccount] = useFromWalletAccount();
    const [toWalletAccount, setToWalletAccount] = useToWalletAccount();
    const selectors = useSelectors();
    const activeWalletAccount = useSelector(selectors.walletAccounts.active);
    const [fromAsset, setFromAsset] = useFromAsset();
    const [toAsset, setToAsset] = useToAsset();
    const config = useConfig();
    const [, _setFromAmount, resetFromAmount] = useFromAmount();
    const [, _setToAmount, resetToAmount] = useToAmount();
    const [, setPrefilledAmountId] = usePrefilledAmountId();
    const assetsByWalletAccounts = useSelector(selectors.assetSources.availableAssetNamesByWalletAccount);
    const assetsInWalletAccount = assetsByWalletAccounts[activeWalletAccount];
    useEffect(() => {
        if (!params)
            return;
        const { fromAssetName, toAssetName } = params;
        if (fromAssetName) {
            setFromAsset(fromAssetName);
            resetFromAmount();
            if (!toAssetName && fromAssetName === toAsset?.name && fromAsset) {
                setToAsset(fromAsset.name);
                resetToAmount();
            }
        }
        if (toAssetName) {
            setToAsset(toAssetName);
            resetToAmount();
            if (!fromAssetName && toAssetName === fromAsset?.name && toAsset) {
                setFromAsset(toAsset.name);
                resetFromAmount();
            }
        }
        setPrefilledAmountId(null);
    }, [params]);
    useEffect(() => {
        if (activeWalletAccount !== fromWalletAccount.toString()) {
            setFromWalletAccount(activeWalletAccount);
            if (assetsInWalletAccount && fromAsset && !assetsInWalletAccount.has(fromAsset.name)) {
                setFromAsset(toAsset?.name === config.defaultFromAsset
                    ? config.defaultToAsset
                    : config.defaultFromAsset);
                resetFromAmount();
            }
        }
        if (activeWalletAccount !== toWalletAccount.toString()) {
            setToWalletAccount(activeWalletAccount);
            if (assetsInWalletAccount && toAsset && !assetsInWalletAccount.has(toAsset.name)) {
                setToAsset(fromAsset?.name === config.defaultToAsset
                    ? config.defaultFromAsset
                    : config.defaultToAsset);
                resetToAmount();
            }
        }
    }, [activeWalletAccount]);
};
export default useSetInitialPair;
